<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup>
// export default {
//   name: "App",
//   components: {},
//   data() {
//     return {};
//   },
// };

// Stop error ResizeObserver
const debounce = (callback, delay) => {
  let tid;
  return function (...args) {
    const ctx = this;
    if (tid) clearTimeout(tid);
    tid = setTimeout(() => {
      callback.apply(ctx, args);
    }, delay);
  };
};

const originalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends originalResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 20);
    super(callback);
  }
};
</script>

<style scoped>
#app :deep(.v-application) {
  /*#f8f8f8*/
  background-color: rgb(248, 248, 248);
}
</style>

<style>
a {
  color: #00c8a8;
}

/* component style overrides */
.v-select .v-select__menu-icon {
  font-size: unset;
}
.v-autocomplete .v-autocomplete__menu-icon {
  font-size: unset;
}

.v-btn .v-icon {
  font-size: unset;
}

/* override the datepicker selected text color */
.v-date-picker .v-date-picker-month__day--selected .v-btn__content {
  color: white !important;
}

/* text colors used for statuses */
.primary--text {
  color: #00c8a8;
}
.error--text {
  color: #f03b48;
}

/*************** Vue 2 Theming Below ************/
/* margin to 0 due to the bug causing checkboxes not align, please ref https://github.com/vuetifyjs/vuetify/issues/3583
 https://github.com/vuetifyjs/vuetify/issues/5372
/**/

/*#app .v-application--wrap {*/
/*  background-color: rgb(248, 248, 248);*/
/*}*/

/*#app :deep(.v-theme--psLightTheme) {*/
/*  !*#f8f8f8*!*/
/*  background-color: rgb(248, 248, 248) !important;*/
/*}*/

/** Navigational Theme Updates **/
/*.theme--dark.v-list-item--active:hover::before,*/
/*.theme--dark.v-list-item--active::before {*/
/*  opacity: 0;*/
/*}*/

/*!** NEW DATATABLE THEMING **!*/
/*.datatable {*/
/*  background: transparent !important;*/
/*}*/
/*.datatable table {*/
/*  padding: 4px 4px;*/
/*}*/
/*.datatable tbody {*/
/*  background: white !important;*/
/*  box-shadow:*/

/*     0 0 0 -1px rgba(0, 0, 0, 0.2), */
/*     0 0 0 0 rgba(0, 0, 0, 0.14), */
/*     0 1px 3px 0 rgba(0, 0, 0, 0.12) !important;*/
/*}*/
/*.datatable th {*/
/*  white-space: nowrap;*/
/*  color: #424242 !important;*/
/*  font-weight: 400 !important;*/
/*  font-size: 14px !important;*/
/*}*/
/*.datatable th.active {*/
/*  color: #4a90e2 !important;*/
/*  font-weight: 600 !important;*/
/*}*/

/*.datatable-action-btn {*/
/*  border: thin solid rgba(0, 0, 0, 0.2);*/
/*}*/
/*!*****************************!*/

/*.v-list-item--link:before {*/
/*  background-color: white;*/
/*}*/
/*.v-list-item--link:hover {*/
/*  background-color: rgba(0, 0, 0, 0.05);*/
/*}*/

/*.cursor-pointer {*/
/*  cursor: pointer;*/
/*}*/

/*.rounded-button {*/
/*  text-transform: none !important;*/
/*  border-radius: 5px;*/
/*  width: 200px;*/
/*}*/

/*.font-14 {*/
/*  font-size: 14px !important;*/
/*}*/

/*!*Button styling*!*/

/*.blue-border {*/
/*  !*used by rounded buttons*!*/
/*  border-color: #4a90e2 !important;*/
/*}*/

/*.agents-overdue-referrals-table .v-table__overflow {*/
/*  width: 100%;*/
/*  overflow-x: auto !important;*/
/*  overflow-y: hidden !important;*/
/*}*/

/*.agents-overdue-referrals-table*/
/*  .theme--light.v-datatable*/
/*  thead*/
/*  th.column.sortable.active,*/
/*.theme--light.v-datatable thead th.column.sortable.active .v-icon,*/
/*.theme--light.v-datatable thead th {*/
/*  color: #424242 !important;*/
/*  font-weight: 400 !important;*/
/*  font-size: 14px !important;*/
/*}*/

/*.agents-overdue-referrals-table .theme--light.v-table thead,*/
/*.agents-overdue-referrals-table .theme--light.v-table thead tr:first-child {*/
/*  border-bottom: none !important;*/
/*}*/

/*.agents-overdue-referrals-table .theme--light.v-table tbody {*/
/*  box-shadow: none !important;*/
/*  -webkit-box-shadow: none !important;*/
/*}*/

/*.more-menu-btn {*/
/*  max-width: 34px !important;*/
/*  max-height: 34px !important;*/
/*  min-height: 34px !important;*/
/*  min-width: 34px !important;*/
/*  background-color: white !important;*/
/*}*/

/*.dashboard-widget-progress-container {*/
/*  width: 100%;*/
/*  min-height: 420px;*/
/*  display: flex;*/
/*  align-items: center;*/
/*  justify-content: center;*/
/*}*/

/*.avatar-center {*/
/*  justify-content: center !important;*/
/*}*/
</style>
